import React from 'react';
import { LazyGigPagePjmBanner } from '@fiverr-private/upmarket_banners';
import { Container } from '@fiverr-private/layout_components';

const GIG_PAGE_PJM_BANNER_CLASS = 'gig-page-pjm-banner';

export const PjmBanner = () => (
  <Container className={GIG_PAGE_PJM_BANNER_CLASS}>
    <LazyGigPagePjmBanner />
  </Container>
);
